import Head from "next/head";
import Footer from "pages/components/HummingFooter";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import ContactForm from "./components/ContactForm";
import FAQ from "./components/FAQ";

import styles from "./styles.module.scss";

const Contact: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Contact Us | Humming Homes</title>
        <meta
          name="description"
          content="Do you want to contact Humming Homes? Reach us out and we are here to listen to you 24/7!"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ContactForm />
      <FAQ />
      <StartHumming fillColor="white" />
    </div>
  );
};

Contact.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Contact;
